import { render, staticRenderFns } from "./PolitiqueConfidentialite.vue?vue&type=template&id=2578d50b&scoped=true&"
import script from "./PolitiqueConfidentialite.vue?vue&type=script&lang=js&"
export * from "./PolitiqueConfidentialite.vue?vue&type=script&lang=js&"
import style0 from "./PolitiqueConfidentialite.vue?vue&type=style&index=0&id=2578d50b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2578d50b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
